import React, {useState} from 'react';
import {Col, Image, Row, Tag, Typography, Radio} from 'antd';
import {css} from "@emotion/react";
import openWindow from "@/script/openWindow.mjs";
import normalizeUrl from '@/biz/normalizeUrl.mjs'

const {Paragraph, Text} = Typography

const cssCard = css({
    // width: 328,
    // height: 200,
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 2px -2px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px, rgba(0, 0, 0, 0.09) 0px 5px 12px 4px',
        borderColor: 'transparent',
        cursor: 'pointer',
        transition: 'box-shadow .3s,border-color .3s',
    },
})
const cssCardContent = css({
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
})
const cssCardContentHeader = css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
})
const cssCardContentTitle = css({
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
})
const cssCardContentImage = css({
    // height: 66,
    // lineHeight: '22px',
    // overflow: 'hidden',
    '& img': {
        objectFit: 'contain'
    }
})
const cssCardContentDescription = css({
    height: 66,
    lineHeight: '22px',
    overflow: 'hidden',
})
const cssCardContentTag = css({
    height: 45,
    // lineHeight: '22px',
    padding: '0 24px 0 24px',
    overflow: 'hidden',
    gap: 12
})
const cssCardCounter = css({
    paddingBottom: 24,
})
const cssCardCounterCol = css({
    textAlign: 'center',
    fontSize: 12,
})
const cssTextRight = css({
    textAlign: 'right',
    paddingRight: 4,
})
const cssTextLeft = css({
    textAlign: 'left',
})

const tagColors = [
    '#f50',
    '#E57C47FF',
    '#108ee9',
    '#87d068',
    '#a8071a',
    '#08979c',
    '#3b5999',
]

const imageFallback = 'data:image/png;base64,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'

const SelCard = ({data, selectedRows, setSelectedRows, ...props}) => {
    const [previewVisible, setPreviewVisible] = useState(false);

    const {pkid, prjId, dpId, dptNo, dptName, dptPicId, dptLabel} = data;

    const handleChange = () => {
        setSelectedRows([{pkid, dpId}])
    }

    return (
        <Col span={6}>
            <div css={[cssCard]} onClick={handleChange}>
                <div css={[cssCardContent]}>
                    <div css={[cssCardContentHeader]}>
                        <Text type='secondary' style={{fontSize: 12}}>{dptNo}</Text>
                        <Radio
                            value={pkid}
                            checked={pkid == selectedRows[0]?.pkid}
                            onChange={handleChange}
                            {...props}
                        />
                    </div>
                    <div css={[cssCardContentTitle]}>
                        <Paragraph ellipsis={{rows: 1,}} style={{marginBottom: 0}}>
                            <Text strong>{dptName}</Text>
                        </Paragraph>
                    </div>
                    <div css={[cssCardContentImage]} onClick={e => e.stopPropagation()}>
                        <Image
                            preview={{
                                visible: false,
                            }}
                            width='100%'
                            height={198}
                            src={dptPicId ? normalizeUrl(`/files/${dptPicId}`) : imageFallback}
                            fallback={imageFallback}
                            onClick={() => setPreviewVisible(true)}
                        />
                        <div
                            style={{
                                display: 'none',
                            }}
                        >
                            <Image.PreviewGroup
                                preview={{
                                    visible: previewVisible,
                                    onVisibleChange: (vis) => setPreviewVisible(vis),
                                }}
                            >
                                {dptPicId && <Image src={normalizeUrl(`/files/${dptPicId}`)}/>}
                            </Image.PreviewGroup>
                        </div>
                    </div>
                </div>
                <div css={cssCardContentTag}>
                    <Paragraph ellipsis={{rows: 2,}} style={{marginBottom: 0}}>
                        {
                            dptLabel &&
                            dptLabel.split(/,|，/).map((label, index) => {
                                return (
                                    <Tag color={tagColors[index % tagColors.length]}>{label}</Tag>
                                )
                            })
                        }
                        {
                            !dptLabel &&
                            <Tag disabled>未设置标签</Tag>
                        }
                    </Paragraph>
                </div>
            </div>
        </Col>
    )
}

export default SelCard;
